module.exports = __webpack_public_path__ + "static/media/AD.c6985df3.svg";